import type { DateRangePickerProps } from '@cloudscape-design/components/date-range-picker';
import type { ReportSearch } from '../api';

function toUtcDateString(date: Date): string {
  return date.toISOString().slice(0, 10);
}

export function rangeToDates(
  range: DateRangePickerProps.Value | null | undefined,
  now: Date = new Date(),
): { from?: string; to?: string } {
  if (!range) return {};
  if (range.type === 'absolute') {
    return { from: range.startDate || undefined, to: range.endDate || undefined };
  }

  const start = new Date(now);
  switch (range.unit) {
    case 'second':
      start.setUTCSeconds(start.getUTCSeconds() - range.amount);
      break;
    case 'minute':
      start.setUTCMinutes(start.getUTCMinutes() - range.amount);
      break;
    case 'hour':
      start.setUTCHours(start.getUTCHours() - range.amount);
      break;
    case 'day':
      start.setUTCDate(start.getUTCDate() - range.amount);
      break;
    case 'week':
      start.setUTCDate(start.getUTCDate() - range.amount * 7);
      break;
    case 'month':
      start.setUTCMonth(start.getUTCMonth() - range.amount);
      break;
    case 'year':
      start.setUTCFullYear(start.getUTCFullYear() - range.amount);
      break;
  }
  return { from: toUtcDateString(start), to: toUtcDateString(now) };
}

export function buildSearch(
  queryText: string,
  searchContent: boolean,
  range: DateRangePickerProps.Value | null | undefined,
  now: Date = new Date(),
): ReportSearch | undefined {
  const query = queryText.trim();
  const { from, to } = rangeToDates(range, now);
  if (!query && !from && !to) return undefined;
  return {
    query: query || undefined,
    searchContent: Boolean(query) && searchContent,
    from,
    to,
  };
}
